import React from "react";
import { Breadcrumb } from "antd";
import { useContext } from "react";
import ReconciliationBankNotesContext from "./ReconciliationBankNotesContext";
import { useState } from "react";
import DynamicSelect from "../../shared/DynamicSelect";
import NumberInput from "../../shared/NumberInput";
import { getDenominationStyles } from "../../../styles/banknotes-styles";
import { formatToCommaSeparate, formatToCommaSeparateKeepMinus, formatToCurrency, parseFormattedNumber } from "../../../helpers/FormatHelper";
import { saveVaultReconciliation } from "../../../networking/NetworkingBankNotes";
import { getBNVaultBalances } from "../../../networking/NetworkingOrders";
import { DeleteTwoTone } from "@material-ui/icons";
import { equalsIgnoreCase } from "../../../helpers/StringHelper";
import { useEffect } from "react";

const denominationStyles = getDenominationStyles();

const DenominationsView = (props) => {

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    
    const { denominations, rowId, item, removeItem, enableRemove, allowEditDenominations, showDifferences } = props;
    const [refresh, setRefresh] = useState(false);

    let editDenominations = [];

    useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [])

    item.ReconciliationDenominations = item.ReconciliationDenominations || [];

    if (Array.isArray(denominations) && denominations.length > 0) {
        editDenominations = denominations.map((d, idx) => {
            const denominationItem = (item.ReconciliationDenominations || []).find(
                (r) => r.DenominationDescription === d.DenominationDescription
            );
            if (denominationItem === undefined) {
                item.ReconciliationDenominations.push({
                    DenominationDescription: d.DenominationDescription,
                    ReportedNoNotes: 0,
                });
            }      
            return (
                <div
                    id={`eo-div-details-rows-${rowId}-den-${idx}-root-${d.DenominationDescription}`}
                    key={`eo-div-details-rows-${rowId}-den-${idx}-root-${d.DenominationDescription}`}
                >
                    <div
                        id={`eo-div-details-rows-${rowId}-den-${idx}-edit-${d.DenominationDescription}`}
                        key={`eo-div-details-rows-${rowId}-den-${idx}-edit-${d.DenominationDescription}`}
                        style={denominationStyles.processingRowHeader}
                    >
                        {d.DenominationDescription}
                    </div>

                    {showDifferences && <div
                        id={`eo-div-in-details-rows-${rowId}-den-${idx}-diff-${d.DenominationDescription}`}
                        key={`eo-div-in-details-rows-${rowId}-den-${idx}-diff-${d.DenominationDescription}`}
                    >
                        <NumberInput
                            id={`eo-in-details-rows-${rowId}-den-${idx}-diff-${d.DenominationDescription}`}
                            key={`eo-in-details-rows-${rowId}-den-${idx}-diff-${d.DenominationDescription}`}
                            className="uk-input"
                            type="Currency"
                            value={denominationItem !== undefined && Number(denominationItem.InventoryNoNotes) !== 0 ? denominationItem.InventoryNoNotes : '0'}
                            onChange={f => f}
                            disabled={true}
                            scale={0}
                            style={denominationStyles.processingRowCellDisabled}
                            negative={true}
                        />
                    </div>}

                    <div
                        id={`eo-div-in-details-rows-${rowId}-den-${idx}-edit-${d.DenominationDescription}`}
                        key={`eo-div-in-details-rows-${rowId}-den-${idx}-edit-${d.DenominationDescription}`}
                    >
                        <NumberInput
                            id={`eo-in-details-rows-${rowId}-den-${idx}-edit-${d.DenominationDescription}`}
                            key={`eo-in-details-rows-${rowId}-den-${idx}-edit-${d.DenominationDescription}`}
                            className="uk-input"
                            type="Currency"
                            value={
                                formatToCommaSeparate(denominationItem !== undefined && Number(denominationItem.ReportedNoNotes) > 0
                                    ? denominationItem.ReportedNoNotes
                                    : "")
                            }
                            onChange={(event) => {
                                if (
                                    event.target.value === "" ||
                                    event.target.value === null ||
                                    event.target.value === undefined
                                ) {
                                    return;
                                }
                                const denominationItem = item.ReconciliationDenominations.find(
                                    (r) => r.DenominationDescription === d.DenominationDescription
                                );                                                                  
                                item.ReportedValue = (item.ReportedValue || 0) - (denominationItem.ReportedNoNotes || 0) * d.DenominationValue;                                
                                denominationItem.ReportedNoNotes = Number(event.target.value);
                                item.ReportedValue = (item.ReportedValue || 0) + denominationItem.ReportedNoNotes * d.DenominationValue;                                
                                setRefresh((refresh) => !refresh);
                            }}
                            disabled={!allowEditDenominations}
                            onBlur={() => {
                                setRefresh((refresh) => !refresh);
                            }}
                            scale={0}
                            style={denominationStyles.processingRowCell}
                        />
                    </div>
                    
                </div>
            );
        });

        
        showDifferences && editDenominations.unshift(
            <div
                id={`eo-root-details-rows-${rowId}-den-reportedvalue-label`}
                key={`eo-root-details-rows-${rowId}-den-reportedvalue-label`}
            >
                <div style={denominationStyles.processingRowHeader}>
                    &nbsp;
                </div>
                <div
                    id={`eo-div-details-rows-${rowId}-den-instock-label`}
                    key={`eo-div-details-rows-${rowId}-den-instock-label`}
                    style={denominationStyles.processingRowHeader}
                >
                    In Stock
                </div>
                <div
                    id={`eo-div-details-rows-${rowId}-den-reportedvalue-label`}
                    key={`eo-div-details-rows-${rowId}-den-reportedvalue-label`}
                    style={denominationStyles.processingRowHeader}
                >
                    Reported
                </div>
            </div>
        );

        editDenominations.push(
            <div
                id={`eo-root-details-rows-${rowId}-den-reportedvalue-edit`}
                key={`eo-root-details-rows-${rowId}-den-reportedvalue-edit`}
                style={{'marginLeft': 'auto'}}
            >
                <div
                    id={`eo-div-details-rows-${rowId}-den-reportedvalue-edit`}
                    key={`eo-div-details-rows-${rowId}-den-reportedvalue-edit`}
                    style={denominationStyles.processingRowHeader}
                >
                    Total
                </div>                
                {   
                    showDifferences &&
                    <div
                        id={`eo-div-details-rows-${rowId}-den-reportedvalue-showDifferences`}
                        key={`eo-div-details-rows-${rowId}-den-reportedvalue-showDifferences`}
                        style={denominationStyles.processingRowCellTotalRec}
                    >
                        <input
                            id={`eo-div-details-rows-${rowId}-den-reportedvalue-showDifferences-in`}
                            key={`eo-div-details-rows-${rowId}-den-reportedvalue-showDifferences-in`}
                            disabled
                            className="uk-input"
                            value={Number(item.InventoryValue) === Number(item.ReportedValue) ? 'No Differences' : 'With Differences'}
                        />
                    </div>
                }
                <div>
                    <NumberInput
                        id={`eo-in-details-rows-${rowId}-den-reportedvalue-edit`}
                        key={`eo-in-details-rows-${rowId}-den-reportedvalue-edit`}
                        className={"uk-input"}
                        type="Currency"
                        value={formatToCurrency(Number(item.ReportedValue) || 0)}
                        disabled={true}
                        style={denominationStyles.processingRowCellTotal}
                    />
                </div>
            </div>
        );
        enableRemove && editDenominations.push(
            <div
                id={`eo-root-details-rows-${rowId}-den-reportedvalue-action`}
                key={`eo-root-details-rows-${rowId}-den-reportedvalue-action`}
            >
                <div
                    id={`eo-div-details-rows-${rowId}-den-reportedvalue-action`}
                    key={`eo-div-details-rows-${rowId}-den-reportedvalue-action`}
                    style={denominationStyles.processingRowHeader}
                >
                    &nbsp;
                </div>
                <div>
                    <DeleteTwoTone
                        style={denominationStyles.processingRowAction}
                        id={`eo-div-details-rows-delete-${rowId}`} key={`eo-div-details-rows-delete-${rowId}`}
                        onClick={() => { removeItem(item) }
                        } />
                </div>
            </div>
        );
    }

    return (
        <div style={windowWidth > 1024 ? denominationStyles.processingRow : denominationStyles.processingRowlgt1}>{editDenominations}</div>
    );
};

const ReconciliationItem = (props) => {

    const { index, item, loadCurrencyDenominations, currencies, editingRow, removeItem, enableRemove, allowEditDenominations, showDifferences, reconciliationIsCompleted } = props;

    const totalInventoryValue = item.ReconciliationDenominations.reduce((sum, item) => {
        const inventoryNoNotesSaved = Number((item.InventoryNoNotesSaved??'0').toString().replace(',', '')) || 0;
        const inventoryNoNotes = Number((item.InventoryNoNotes??'0').toString().replace(',', '')) || 0;
        const inventaryValue = reconciliationIsCompleted ? inventoryNoNotesSaved : inventoryNoNotes;
        const value = Number(inventaryValue * item.DenominationValue) || 0;
        return sum + value;
    }, 0);
    item.InventoryValue = totalInventoryValue
    
    const [currency, setCurrency] = useState({});    
    const [refresh, setRefresh] = useState(false);

    const onSelectCurrency = (event) => {
        let value = event.value;
        setCurrency(value);

        loadCurrencyDenominations(item, value);
        setRefresh(!refresh);
    };

    let denominationView = [];

    let itemDenominations = item.ReconciliationDenominations || [];
    if (itemDenominations && Array.isArray(itemDenominations)) {
        denominationView.push(
            <DenominationsView
                key={`recon-row-${index}`}
                rowId={index}
                denominations={itemDenominations}
                currency={currency}
                item={item}
                currencies={currencies}
                onSelectCurrency={onSelectCurrency}
                removeItem={removeItem}
                enableRemove={enableRemove}
                allowEditDenominations={allowEditDenominations}
                showDifferences={showDifferences}
            />
        );
    }

    return (
        <>
            <div style={{ display: "flex", direction: "row", alignItems: "center", gap: "2rem", width: '75%',  }}>
                <>{editingRow && item.CurrencyID !== '' ?
                    <div style={denominationStyles.processingRowHeaderCurrency}>{item.CurrencyID}</div> :
                    <DynamicSelect
                        id={`s-currency-${index}`}
                        className={"uk-select"}
                        placeholder="Select a currency"
                        placeholderValue=""
                        data={currencies}
                        objValue={{ value: currency }}
                        getValue={onSelectCurrency}
                    />}
                </>
                <>
                    {denominationView}
                </>
            </div>
            <hr style={{ margin: '0.1rem' }} />
        </>
    );
};

const ReconciliationBankNotesForm = (props) => {
    const {
        dateReported,
        vaultSelected,
        vaultReconciliationRecord,
        alertMessage,
        setAlertMessage,
        currencyDenominations,
        currencies,
        confirmationMessage,
        setConfirmationMessage,
        isBankNotesAdmin = false,
        loading,
        setLoading,
        showDifferences,
        vaultBalances,
        setVaultBalances,
        loadVaultReconciliation,
        setVaultReconciliationRecord

    } = useContext(ReconciliationBankNotesContext);

    const reconciliationIsCompleted = equalsIgnoreCase(vaultReconciliationRecord.Status || 'completed', 'Completed')
    const allowSaveInProgress = !reconciliationIsCompleted || isBankNotesAdmin
    const allowEditDenominations = !reconciliationIsCompleted || isBankNotesAdmin    

    const [refresh, setRefresh] = useState(false);    

    const addCurrency = () => {        
        let item = { CurrencyID: "", ReportedValue: 0 };
        vaultReconciliationRecord.ReconciliationItems.push(item);
        setRefresh(!refresh);
    };

    const loadCurrencyDenominations = (item, currencyId) => {

        item.CurrencyID = currencyId;
        const currencyDetails = currencyDenominations.find(
            (c) => c.CurrencyID === currencyId
        );        

        if (currencyDetails && currencyDetails.Denominations) {            
            item.ReconciliationDenominations = currencyDetails.Denominations;
        } else {
            item.ReconciliationDenominations = [];
        }
        setRefresh(!refresh);
    };

    const removeItem = (item) => {
        vaultReconciliationRecord.ReconciliationItems = vaultReconciliationRecord.ReconciliationItems.filter(i => i.CurrencyID !== item.CurrencyID)
        setRefresh(!refresh)
    }

    let recordView = [];
    if (Array.isArray(vaultReconciliationRecord.ReconciliationItems)) {
        let currentSelectedCurrencies = vaultReconciliationRecord.ReconciliationItems.map(item => item.CurrencyID) || []
        recordView = vaultReconciliationRecord.ReconciliationItems.map(
            (item, index) => (                
                <ReconciliationItem key={index} item={item} index={index}
                    loadCurrencyDenominations={loadCurrencyDenominations}
                    currencies={currencies.filter(c => !currentSelectedCurrencies.includes(c.value))}
                    editingRow={item.ReconciliationDenominations !== undefined && item.ReconciliationDenominations.length > 0 && item.CurrencyID !== ''}
                    removeItem={removeItem}
                    enableRemove={!reconciliationIsCompleted}
                    allowEditDenominations={allowEditDenominations}
                    showDifferences={showDifferences}
                    reconciliationIsCompleted={reconciliationIsCompleted} />
            )
        );
    }

    const onSave = async (finalSubmit) => {        
        const validationMessage = await validateBalanceStocks(false)
        let message = 'Please confirm all the information is Ok before the final submit. Do you want to proceed'
        if (validationMessage !== '') {
            message = validationMessage
        }
        
        if (finalSubmit) {
            setConfirmationMessage({
                ...confirmationMessage, show: true, title: 'Confirm',
                message: message,
                callback: onFinalSubmit
            }
            )
        } else {
            vaultReconciliationRecord.Status = 'In Progress'
            saveReconciliation(false)
        }
    }

    const onFinalSubmit = async () => {

        vaultReconciliationRecord.Status = 'Completed'
        vaultReconciliationRecord.StatusVariance = 'No Differences'
        vaultReconciliationRecord.TotalInventoryValue = 0

        const validationMessage = await validateBalanceStocks(true)

        let differences = false;        
        if (validationMessage !== '') {
            differences = true
        }

        if (differences) {
            vaultReconciliationRecord.StatusVariance = 'With Differences'
        }

        saveReconciliation(true)
    }

    const validateBalanceStocks = async (forFinalSubmit) => {

        let validationMessage = ''
        const vaultId = vaultReconciliationRecord.VaultReconciliationID > 0 ? vaultReconciliationRecord.VaultID : vaultSelected.id
        
        let differences = false;

        const balances = vaultBalances        

        const groupedByCurrency = balances.reduce((acc, item) => {
            const currency = item.Currency;
            const inStock = parseFormattedNumber(item['In Stock']) || 0;

            const existingCurrency = acc.find(entry => entry.currency === currency);

            if (existingCurrency) {
                existingCurrency.stock += (inStock * Number(item['Denomination Description']));
            } else {
                acc.push({ currency, stock: inStock * Number(item['Denomination Description']) });
            }
            return acc;
        }, []);

        const groupedByCurrencyNoZeroStock = groupedByCurrency.filter((s) => s.stock > 0)

        let currenciesNoReconciliated = []

        groupedByCurrencyNoZeroStock.forEach(s => {
            const item = vaultReconciliationRecord.ReconciliationItems.find(item => s.currency === item.CurrencyID)
            if (item === undefined || item == null) {
                differences = true;
                currenciesNoReconciliated.push(
                    {
                        "CurrencyID": s.currency,
                        "InventoryValue": s.stock,
                        "ReportedValue": 0,
                        "ReconciliationDenominations": balances.filter(b => b.Currency === s.currency).map(b => {
                            return {
                                DenominationDescription: b['Denomination Description'],
                                InventoryNoNotes: Number((b['In Stock']??'0').toString().replace(',', '')) || 0,
                                ReportedNoNotes: 0,
                                DenominationValue: Number((b['Denomination Description']??'0').toString().replace(',', '')) || 0,
                            }
                        })
                    }
                )
                return;
            }

            const reportedvalue = item.ReportedValue || 0
            if (s.stock !== reportedvalue) {
                console.log('s.stock', s.stock, 'reportedvalue', reportedvalue)
                console.log('item', item, 's', s)
                differences = true;
            }
        })

        if (forFinalSubmit) {
            currenciesNoReconciliated.forEach(c => {
                vaultReconciliationRecord.ReconciliationItems.push(c)
            })

            vaultReconciliationRecord.ReconciliationItems.forEach(item => {
                const balance = groupedByCurrencyNoZeroStock.find(s => s.currency === item.CurrencyID)
                item.InventoryValue = balance ? balance.stock : 0
                if (item.InventoryValue !== item.ReportedValue) {
                    console.log('item.InventoryValue', item.InventoryValue, 'item.ReportedValue', item.ReportedValue)
                    console.log('item', item)
                    differences = true;
                }
            })
        }

        if (differences) {
            validationMessage = 'There are differences between reported and in-stock values. Do you want to proceed?'
        }

        return validationMessage;
    }

    const saveReconciliation = async (finalSubmit = false) => {
        vaultReconciliationRecord.TotalReportedValue = vaultReconciliationRecord.ReconciliationItems.reduce((total, item) => total + (Number(item.ReportedValue) || 0), 0);
        if(vaultReconciliationRecord.ReconciliationItems) {
            vaultReconciliationRecord.ReconciliationItems.forEach(item => {                
                item.ReconciliationDenominations.forEach(den => {
                    den.InventoryValue = (Number((den.InventoryValue??'0').toString().replace(',', '')) || 0)
                    den.InventoryNoNotes = (Number((den.InventoryNoNotes??'0').toString().replace(',', '')) || 0)
                    den.ReportedValue = (Number((den.ReportedNoNotes??'0').toString().replace(',', '')) || 0)
                })
            })
        }
        setLoading(true)
        const response = await saveVaultReconciliation(vaultReconciliationRecord.VaultReconciliationID, vaultReconciliationRecord, vaultReconciliationRecord.UpdateToken)
        setLoading(false)

        if (response.success) {
            setAlertMessage({ ...alertMessage, show: true, title: 'Sucess', message: `Reconciliation saved successfully` })
            props.back()
        } else if (response.VaultBalanceCollution) {
            let alertMsg = 'Balances changed since the reconciliation data was loaded and have been reloaded. Review the differences and resubmit.'
            if (response.Message) {
                alertMsg = response.Message + ' ' + alertMsg
            }
            setAlertMessage({
                ...alertMessage, show: true, title: 'Error',
                message: alertMsg
            })
            if (finalSubmit) {
                vaultReconciliationRecord.Status = 'In Progress'
                vaultReconciliationRecord.StatusVariance = ''
                vaultReconciliationRecord.TotalInventoryValue = 0
            }
            //this logic is from loadVaultReconciliation of the Provider, keep in sync with any changes there
            setLoading(true)
            const balancesResponse = await getBNVaultBalances({ vaultId: vaultReconciliationRecord.VaultID });
            setLoading(false)

            let vaultBalances = []
            if (balancesResponse && Array.isArray(balancesResponse.result) && balancesResponse.result.length > 0) {
                vaultBalances = balancesResponse.result
                setVaultBalances(vaultBalances) // set balances in context for use in form and to avoid calling API again when needed                        
            } else {
                setVaultBalances([]) // set empty to avoid issues in form if API call fails or returns no data
            }

            vaultReconciliationRecord.ReconciliationItems.forEach(item => {

                // helper to find matching balance entry
                const findBalance = (currencyId, denomDesc) => {
                    if (!Array.isArray(vaultBalances)) return null;
                    return vaultBalances.find(b => b.Currency === currencyId && b['Denomination Description'] === denomDesc) || null;
                }

                item.ReconciliationDenominations.forEach(den => {
                    const balanceForItemCurrency = findBalance(item.CurrencyID, den.DenominationDescription);

                    den.InventoryNoNotes = balanceForItemCurrency ? balanceForItemCurrency['In Stock'] : 0
                    den.ReportedNoNotes = 0
                    den.InventoryValue = den.InventoryNoNotes
                    den.VbUpdateToken = balanceForItemCurrency ? balanceForItemCurrency['VbUpdateToken'] : ''
                })
                // kept: list of balances for this currency if needed elsewhere
                const balanceForItemCurrency = vaultBalances.filter(b => b.Currency === item.CurrencyID)

            })
            setVaultReconciliationRecord(vaultReconciliationRecord)

        } else {
            setAlertMessage({
                ...alertMessage, show: true, title: 'Error',
                message: response !== undefined
                    ? response.Message
                    : 'Something went wrong. Please try again later.'
            })
        }
    }

    return (
        <div>
            <div className="breadcrumb-div">
                <Breadcrumb separator=">">
                    <Breadcrumb.Item className={"breadcrumb-item"} onClick={props.back}>
                        Reconciliation
                    </Breadcrumb.Item>
                    <Breadcrumb.Item className="breadcrumb-item-bold">{`Date Reported: ${vaultReconciliationRecord.VaultReconciliationID > 0 ? vaultReconciliationRecord.DateReported : dateReported}`}</Breadcrumb.Item>
                </Breadcrumb>
            </div>

            <div className="uk-grid uk-margin uk-width-1-1">
                <div className="uk-width-1-3">
                    <div className="uk-width-1-1">
                        <label className="uk-form-label">Vault</label>
                    </div>
                    <div className="uk-width-1-1">
                        <input
                            id="rc-in-vault-id"
                            disabled
                            className="uk-input"
                            value={vaultReconciliationRecord.VaultReconciliationID > 0 ? (vaultReconciliationRecord.VaultDescription) : `${vaultSelected.name} - ${vaultSelected.id}`}
                        />
                    </div>
                </div>
                <div className="uk-width-1-3">
                    <div className="uk-width-1-1">
                        <label className="uk-form-label">Status</label>
                    </div>
                    <div className="uk-width-1-1">
                        <input
                            id="rc-in-vault-status"
                            disabled
                            className="uk-input"
                            value={vaultReconciliationRecord.Status || ''}
                        />
                    </div>
                </div>
            </div>
            <hr />
            
            <div style={{ display: 'flex', gap: '2rem', flexDirection: 'row' }}>
                {allowSaveInProgress && <button
                    id="rc-b-save"
                    className="uk-button uk-button-green"
                    type="button"
                    onClick={() => onSave(false)}>
                    Save In Progress
                </button>}
                <button
                    id="rc-b-finalsubmit"
                    className="uk-button uk-button-green"
                    type="button"
                    onClick={() => onSave(true)}
                    disabled={reconciliationIsCompleted || loading}>
                    Final Submit
                </button>
            </div>
            <hr style={{ marginBottom: '0.1rem' }} />

            <div>{recordView}</div>
        </div>
    );
};

export default ReconciliationBankNotesForm;
